'use strict';

import {find, findAll, register} from '../../../JavaScript/Utils';

const TabbedContent = $el => {
    const $tabbedContents = findAll('[data-nezzo-tabbed-content]', document);

    $tabbedContents.forEach($tabbedContent => {
        const $toggleTabs = findAll('[data-nezzo-tab-content]', $tabbedContent);

        $toggleTabs.forEach($tab => {
            $tab.addEventListener('click', event => {
                event.preventDefault();

                const activeClass = 'active';
                const showPanel = event.target.dataset.nezzoTabContent;
                const $allActives = findAll(`.tabs__panel.${activeClass}, .tabs__controls--item.${activeClass}`, $tabbedContent);
                const $activePanel = find(`[data-nezzo-tab-target="${showPanel}"]`, $tabbedContent);

                $allActives.forEach($active => {
                    $active.classList.remove(activeClass);
                });

                event.target.classList.add(activeClass);
                $activePanel.classList.add(activeClass);
                // slick slider uses jquery
                $('[data-nezzo-contentslider]').slick('reinit');
                ariInstance.init();
            });
        });

        /* TODO kp: do we need this -> Desktop horizontal nav scroll ---------------------------- */
        const $scrollNav = findAll('[data-nezzo-tabbed-content-scroll-nav]', $tabbedContent);
        $scrollNav.forEach($nav => {
            const box = find('.tabs__controls', $nav);
            let mx = 0;

            box.addEventListener('mousemove', (event) => {
                const mx2 = event.pageX - box.offsetLeft;

                if (mx) {
                    box.scrollLeft = box.sx + mx - mx2;
                }
            });

            box.addEventListener('mousedown', (event) => {
                box.sx = box.scrollLeft;
                mx = event.pageX - box.offsetLeft;
            });

            document.addEventListener('mouseup', () => {
                mx = 0;
            });
        });
    });
};

register('TabbedContent', TabbedContent);
